
eval("define(\'text!orocrmchannel/js/entity-management/templates/select2/result.html\',[],function () { return \'<% if (icon) { %><i class=\"<%= icon %> hide-text\"></i><% } %>&nbsp;<%= highlight(_.escape(text)) %>\\n\';});\n\n//# sourceURL=/text!orocrmchannel/js/entity-management/templates/select2/result.html");

